<template>
    <div id="users" class="root">
        <div class="row">
            <div class="col-lg-12 content-body">
                <div class="user-list component-list">
                    <div class="row">
                        <button class="pl-4 btn btn-primary" v-if="is_signed_in" @click="signOut">
                            <i class="fab fa-google"></i> Kijelentkezés  a Google fiókból ({{ googleUser.name }})</button>
                        <button class="pl-4 btn btn-danger" v-if="!is_signed_in" @click="signIn">
                            <i class="fab fa-google"></i> Jelentkezzen be Google-al</button>
                        <p class="text-danger m-3 pl-4 p-2 bg-primary text-light" v-if="!is_signed_in">
                            <i class="fas fa-info-circle text-light"></i> Jelentkezzen be a Google fiókjába a fenti gombra kattintva, hogy a Google Analytics adatok elérhetőek legyenek az Ön számára.
                        </p>
                    </div>
                    <div class="pl-1 pt-3 col-lg-12 text-secondary pr-lg-4 mb-4">
                        <div v-if="is_signed_in">
                            <i class="fas fa-info-circle text-secondary mr-2" v-if="message != ''"/> {{ message }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 text-right text-primary pr-lg-4 mb-4">
                            {{ post_pagination.total ? post_pagination.total : 0 }} találat
                        </div>
                    </div>
                    <div class="row form-group">
                        <table class="table table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="text-left" width="10%">#</th>
                                <th scope="col" class="text-left" width="55%">Cím / Tartalom</th>
                                <th scope="col" class="text-center" width="15%">Szerző</th>
                                <th scope="col" class="text-right" width="15%">Látogatók</th>
                                <th scope="col" width="5%"></th>
                            </tr>
                            </thead>
                            <tbody v-if="!loading_status">
                            <tr v-for="item in post_list" v-bind:data="item" v-bind:key="item.id" :class="{'td-deleted' : !item.is_active}">
                                <th scope="row" class="text-left" width="10%">
                                    <div class="thumb">
                                        <a v-on:click.stop.prevent="" class="cat-flag" v-if="item.post_type">{{ item.post_type }}</a>
                                        <a v-on:click.stop.prevent="editPost(item.id)" class="text-primary">
                                            <img :src="item.thumbnail+'?height=200'" class="zoom w-100"/>
                                        </a>
                                    </div>
                                </th>
                                <td class="text-left" valign="top" width="55%">
                                   <div class="row item-title-row">
                                       <div class="col-lg-12 p-2 item-title">
                                           <h5 class="c-pointer" @click="editPost(item.id)">{{ getTitle(item.title) }}</h5>
                                       </div>
                                   </div>
                                    <div class="row">
                                        <div class="col-lg-12 p-2 item-short-content">
                                            {{ item.short_content }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12 p-2 item-keywords">
                                            <div class="tag" v-for="kw in getKeywords(item.keywords)">
                                                <a v-on:click.prevent="">{{ kw }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td align="center" valign="top" width="15%">
                                    <div class="row">
                                        <div class="col-lg-12 text-center">
                                            {{ item.full_name }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12 text-center">
                                            {{ item.creation_date }}
                                        </div>
                                    </div>
                                </td>
                                <td class="text-right visitors" valign="top" width="15%">
                                    <div class="row justify-content-right">
                                        <div class="col-lg-8 text-right">
                                            <i class="far fa-eye" title="Összes látogató"></i>
                                        </div>
                                        <div class="col-lg-4 text-right font-weight-bold">
                                            {{ (parseInt(item.desktop_visitors) + parseInt(item.mobile_visitors)) ? (parseInt(item.desktop_visitors) + parseInt(item.mobile_visitors))  : '-' }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-8 text-right">
                                            <i class="fas fa-desktop" title="Asztali gépről érkezett látogatók"></i>
                                        </div>
                                        <div class="col-lg-4 text-right">
                                            {{ item.desktop_visitors ? item.desktop_visitors : '-' }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-8 text-right">
                                            <i class="fas fa-mobile-alt vmobile" title="Telefonról érkezett látogatók"></i>
                                        </div>
                                        <div class="col-lg-4 text-right">
                                            {{ item.mobile_visitors ? item.mobile_visitors : '-' }}
                                        </div>
                                    </div>
                                    <div class="row d-none">
                                        <div class="col-lg-8 text-right">
                                            <i class="fas fa-robot" title="Androidról érkezett látogatók"></i>
                                        </div>
                                        <div class="col-lg-4 text-right">
                                            {{ item.visitors_android }}
                                        </div>
                                    </div>
                                </td>
                                <td width="5%">
                                    <a v-on:click.prevent="editPost(item.id)" title="Szerkesztés"><i class="far fa-edit text-success"></i></a>
                                    <a v-on:click.prevent="confirmDelete(item)" title="Törlés"><i class="fas fa-trash-alt text-danger"></i></a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <loader :loading="loading_status"></loader>
                    <div class="row" v-if="!loading_status">
                        <div class="col-lg-12">
                            <pagination :data="pagination_data"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "../common/controls/Pagination";
    import Loader from '../common/controls/Loader'
    import { mapGetters, mapActions } from 'vuex'
    import moment from "moment";

    export default{
        name: 'posts',
        props: ['onFiltersApplied'],
        data(){
            return{
                meta: [
                    {name: 'google-signin-client_id', content: '872471067493-fn7ghqup7gptebctsdj5hs48k1agtp3u.apps.googleusercontent.com'}
                ],
                is_signed_in: false,
                query: false,
                message: '',
            }
        },
        components: {
            Pagination,
            Loader
        },
        computed: {
            ...mapGetters([
                'posts',
                'getPagination',
                'postFilters',
                'loading',
                'googleUser',
                'postsLoaded',
            ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            pagination_data: {
                get: function() {
                    return {
                        pagination: this.post_pagination,
                        navigationMethod: this.navigationMethod,
                    }
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            post_list: {
                get: function() {
                    return this.posts;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            post_pagination: {
                get: function() {
                    return this.getPagination;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            post_filters: {
                get: function() {
                    return this.postFilters;
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        methods: {
            ...mapActions([
                'deletePost',
                'getPosts',
            ]),
            navigationMethod(page_id) {
                let vm  = this;
                this.$set(this.post_filters, 'page', page_id);

                this.getPosts({
                    filters: this.post_filters,
                });
            },
            editPost(id) {
                if(id) {
                    this.$router.push({
                        name: 'postDetails',
                        params: {
                            id: id,
                        }
                    });
                }
            },
            confirmDelete(item) {
                let vm = this;
                this.$dialog.confirm('Tényleg szeretné törölni a "'+item.title+'" cikket?', {})
                    .then((dialog) => {
                        vm.deletePost({
                            list: true,
                            id: item.id,
                        }).then((response) => {
                            dialog.close();
                        });
                    });
            },
            getKeywords(keywords) {
                if(keywords) {
                    return keywords.split(',');
                }
            },
            getTitle(title) {
                if(title) {
                    return title.replace(/&quot;/g, '"');
                }

                return '';
            },
            signIn() {
                let vm = this;
                this.$gapi.signIn().then(user => {
                    console.log('Signed in as %s', user.name, 'user data', user);
                    vm.is_signed_in = true;
                    vm.$store.commit('setGoogleUser', user);
                    vm.getPostListVisitors();
                })
                .catch(err => {
                    console.error('Sign in error : %s', err.error);
                    console.log('Sign in exception', err);
                    vm.is_signed_in = false;
                    vm.$store.commit('setGoogleUser', {});
                });
            },
            signOut() {
                let vm = this;
                this.$gapi.signOut().then(user => {
                    console.log('Google Signed out!');
                    vm.is_signed_in = false;
                    vm.$store.commit('setGoogleUser', {});
                })
                .catch(err => {
                    console.error('Google Signed out Error!', err);
                });
            },
            isSignedIn() {
                let vm = this;
                this.$gapi.isSignedIn()
                    .then(result => {
                        if(!result) {
                            console.log('Not signed in');
                            vm.is_signed_in = false;
                        } else {
                            console.log('signed in as ', result);
                            vm.is_signed_in = true;
                            vm.getPostListVisitors();
                        }
                    })
            },
            getPostListVisitors() {
                let vm = this;
                let post_filters_ = [];
                let start_date = this.getStartDate();
                let end_date = moment(new Date()).format('YYYY-MM-DD');

                this.post_list.map((item) => {

                  if(item.post_url) {
                    let url = item.post_url.substring(1, item.post_url.length -1);

                    if(url.length > 90) {
                      url = url.substring(0, 90);
                    }

                    post_filters_.push('ga%3ApagePath%3D~'+url);
                  }
                });

                if(post_filters_ && post_filters_.length > 0) {
                  this.message = 'Analytics adatok betöltése folyamatban ...';

                  //iterate posts, get visits
                  this.iterateQuery(0)
                } else {
                  console.log('error post filters is not set, no post url?');
                }

            },
            iterateQuery(index) {
              let post = null;
              if(this.posts[index]) {
                  post = this.posts[index];
              } else {
                console.log('post not exists on index', index);
                this.message = '';
                return;
              }

              let vm = this;
              setTimeout(function() {
                let GA4_QUERY_BODY = {"dimensions":[{"name":"deviceCategory"},{"name":"pagePath"}],"metrics":[{"name":"screenPageViews"}],"dateRanges":[{"startDate":"2013-01-1","endDate":"today"}],"dimensionFilter":{"filter":{"fieldName":"pagePath","stringFilter":{"matchType":"CONTAINS","value":post.post_url,"caseSensitive":false}}},"keepEmptyRows":true,"metricAggregations":["TOTAL"]}
                vm.$gapi.request({
                  path: 'https://analyticsdata.googleapis.com/v1beta/properties/'+vm.$GA4_PROPERTY_ID+':runReport',
                  method: 'POST',
                  body: GA4_QUERY_BODY
                }).then(response => {
                  vm.buildVisits(response.result);
                }).catch((e) => {
                  console.log('analytics data load error', e);
                  vm.message = 'Hiba az Analytics adatok betöltése közben. Kérjük próbálja újra vagy frissítse az oldalt.';

                  if(e.status === 304) {
                    //?????
                    //vm.getPostListVisitors();
                  }
                }).finally(() => {
                  if(index < vm.posts.length) {
                    index++;
                    vm.iterateQuery(index);
                  } else {
                    vm.message = '';
                  }
                });

                //timeout
              }, 600)
            },
            buildVisits(result) {
                let vm = this;
                if(result && result.rows) {
                  result.rows.map((row) => {
                      let type = row.dimensionValues[0].value;
                      let postUrl = row.dimensionValues[1].value;
                      let count = row.metricValues[0].value
                        vm.updatePostVisitor(postUrl, type, count);
                    });
                }
            },
            updatePostVisitor(post_url, type, count) { //mobile_visitors, desktop_visitors, total_visitors
                let vm = this;
                let found = this.post_list.find(p => p.post_url == post_url);
                let update = Object.assign({}, found);

                if(found) {

                    if(!Number.isInteger(update.mobile_visitors)) {
                      update.mobile_visitors = 0;
                    }

                    if(!Number.isInteger(update.desktop_visitors)) {
                      update.desktop_visitors = 0;
                    }

                    if(!Number.isInteger(update.total_visitors)) {
                      update.total_visitors = 0;
                    }

                    switch(type) {
                        case 'mobile':
                          update.mobile_visitors += parseInt(count);
                            //found.total_visitors += parseInt(count);
                            break;
                        case 'tablet':
                          update.mobile_visitors += parseInt(count);
                            //found.total_visitors += parseInt(count);
                            break;
                        case 'desktop':
                          update.desktop_visitors = parseInt(count);
                            //found.total_visitors += parseInt(count);
                            break;
                        default:
                            break;
                    }

                  //console.log('updating ', update.post_url, '-' + update.title, 'type: ', type, 'count', count);

                    this.post_list.splice(this.post_list.indexOf(found), 1, update);
                }
            },
            visitsPopulated() {
                let populated = [];

                if(this.post_list) {
                    populated = this.post_list.filter((item) => {
                        return item.total_visitors !== undefined;
                    });
                }

                return populated.length > 0;
            },
            getStartDate() {
                let toSort = Object.assign([], this.post_list);
                toSort.sort((a, b) => (a.creation_date > b.creation_date) ? 1 : -1);
                return moment(toSort[0].creation_date).format('YYYY-MM-DD');
            },
        },
        mounted(){
            this.query = false;
            this.isSignedIn();
        },
        watch: {
            getPagination: function(newVal) {
                this.post_pagination = newVal;
            },
            pagination_data: function(newVal) {
                this.pagination_data = newVal;
            },
            posts: function(newVal) {
                this.post_list = newVal;
            },
            is_signed_in: function(newVal) {
                if(!newVal) {
                    this.$store.commit('setGoogleUser', {});
                }
            },
            onFiltersApplied: function(newVal) {
                this.query = false;
                console.log('onFiltersApplied watch', newVal);
            },
            postsLoaded: function(newVal) {
                console.log('posts loaded watch', newVal);
                this.post_list = this.post_list.map((item) => {
                    item.total_visitors = 0;
                    item.mobile_visitors = 0;
                    item.desktop_visitors = 0;
                });

                this.getPostListVisitors();
            }
        },
    }
</script>

<style scoped="" lang="scss">
    .user-list {
        overflow: auto;

        tr {
            td > i {
                cursor: pointer;
                padding: 3px;
            }
        }
    }

    @media (max-width: 576px) {
        .user-list {
            overflow: auto;
        }

        .content-title {
            i {
                left: 88% !important;
            }
        }
    }

    button{
        padding-bottom: 7px;
    }
    .product-finder{
        margin-top: 70px;
    }
    table{
        margin-left: 15px;
        margin-right: 15px;

        .thumb {
            width: 150px;
            height: 88px;
            overflow: hidden;
            border-radius: 4px;
            position: relative;

            .cat-flag {
                background-color: #b31717;
                top: 5px;
                left: -16px;
                color: white;
            }

            .cat-flag:before {
                border-top: 8px solid #b31717;
            }
        }

        .item-title-row {
            height: 35px;
        }

        .item-title {
            max-height: 55px;
            overflow: hidden;
            position:  relative;
            top: -10px;
        }

        .item-short-content {
            height: 25px;
            overflow: hidden;
        }

        .visitors .vmobile {
            margin-right: 4px;
        }
    }
    .action-buttons input[type=checkbox]{
        position: relative;
        top: 1px;
        right: 3px;
    }

    .panel-heading{
        background-color: white;
        color: #42A5F5;
    }

    td i {
        cursor: pointer;
    }

    tr {
        td, th {
            a {
                cursor: pointer;
            }
        }
    }

    .item-keywords {
        width: 100px;
        white-space: nowrap;
        overflow: hidden;
    }

</style>
